import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  leadRecords: [],
  leadRecordById: null,
  totalPages: 0,
  currentPage: 1,
  statusCount: null,
  monthlyStatus: [],
  sourceOfLeadCount: [],
  leadCallList: [],
  leadCallById: null,
  leadNoteList: [],
  leadNoteById: null,
  leadEmailsList: [],
  leadEmailById: null,
  activitiesByDate: [],
};

export const LeadSlice = createSlice({
  name: "leads",
  initialState,
  reducers: {
    setLeadRecords: (state, action) => {
      const { data, totalPages, pageNo, isSearch } = action.payload;

      if (isSearch) {
        state.leadRecords = data;
        state.currentPage = 1;
      } else {
        const updatedLeadsMap = new Map(data.map((item) => [item.id, item]));

        state.leadRecords = state.leadRecords.map((lead) =>
          updatedLeadsMap.has(lead.id) ? updatedLeadsMap.get(lead.id) : lead
        );

        const newLeads = data.filter(
          (newLead) => !state.leadRecords.some((lead) => lead.id === newLead.id)
        );

        state.leadRecords = [...state.leadRecords, ...newLeads];
      }

      state.totalPages = totalPages;
      state.currentPage = pageNo;
    },
    resetLeadRecords: (state) => {
      state.leadRecords = null;
    },
    setLeadById: (state, action) => {
      state.leadRecordById = action.payload;
    },
    resetLeadById: (state) => {
      state.leadRecordById = null;
    },
    setLeadStatusCount: (state, action) => {
      state.statusCount = action.payload;
    },
    setMonthlyLeadStatuses: (state, action) => {
      state.monthlyStatus = action.payload;
    },
    setSourceOfLeadCount: (state, action) => {
      state.sourceOfLeadCount = action.payload;
    },
    setLeadCallsList: (state, action) => {
      //state.leadCallList = action.payload;
      if (action.payload.pageNumber === 1) {
        state.leadCallList = action.payload.items;
      } else {
        state.leadCallList = [...state.leadCallList, ...action.payload.items];
      }
    },
    setLeadCallById: (state, action) => {
      state.leadCallById = action.payload;
    },
    resetLeadCallById: (state) => {
      state.leadCallById = null;
    },
    setLeadNotesList: (state, action) => {
      //state.leadNoteList = action.payload;
      if (action.payload.pageNumber === 1) {
        state.leadNoteList = action.payload.items;
      } else {
        state.leadNoteList = [...state.leadNoteList, ...action.payload.items];
      }
    },
    resetLeadNotesList: (state) => {
      state.leadNoteList = [];
    },
    setLeadNoteById: (state, action) => {
      state.leadNoteById = action.payload;
    },
    setLeadEmailsList: (state, action) => {
      //state.leadEmailsList = action.payload;
      if (action.payload.pageNumber === 1) {
        state.leadEmailsList = action.payload.items;
      } else {
        state.leadEmailsList = [
          ...state.leadEmailsList,
          ...action.payload.items,
        ];
      }
    },
    resetLeadEmailsList: (state) => {
      state.leadEmailsList = [];
    },
    setLeadEmailById: (state, action) => {
      state.leadEmailById = action.payload;
    },
    setActivitiesByDate: (state, action) => {
      //state.activitiesByDate = action.payload;
      const newItems = action.payload.items || [];
      const currentPage = action.payload.pageNumber || 1;

      if (currentPage > 1) {
        const merged = [...state.activitiesByDate];

        newItems.forEach((newGroup) => {
          const existingGroup = merged.find((g) => g.date === newGroup.date);
          if (existingGroup) {
            existingGroup.activities = [
              ...existingGroup.activities,
              ...newGroup.activities,
            ];
          } else {
            merged.push(newGroup);
          }
        });

        state.activitiesByDate = merged;
      } else {
        state.activitiesByDate = newItems;
      }
    },
    resetActivitiesByDate: (state) => {
      state.activitiesByDate = [];
    },
  },
});

export const {
  setLeadRecords,
  resetLeadRecords,
  setLeadById,
  resetLeadById,
  setLeadStatusCount,
  setMonthlyLeadStatuses,
  setSourceOfLeadCount,
  setLeadCallsList,
  setLeadCallById,
  resetLeadCallById,
  setLeadNotesList,
  setLeadNoteById,
  resetLeadNotesList,
  setLeadEmailsList,
  resetLeadEmailsList,
  setLeadEmailById,
  setActivitiesByDate,
  resetActivitiesByDate,
} = LeadSlice.actions;
export default LeadSlice.reducer;
